// src/components/PayoutSummary.js

import React from 'react';

// Helper to format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount);
};

const PayoutSummary = ({ 
  subtotal, 
  commission, 
  processingFee, 
  totalPlatformFee, 
  netPayout, 
  selectedProject, 
  feeBreakdown,
  hideTitle = false,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm text-base text-gray-900">
      {!hideTitle && <h3 className="font-bold mb-4 text-gray-900">Your Payout Summary</h3>}
      
      <div className="flex justify-between mb-2 text-gray-800">
        <span>Subtotal</span>
        <span>{formatCurrency(subtotal)}</span>
      </div>
      
      <div className="flex justify-between mb-2 text-gray-800">
        <span>Boutee Commission {selectedProject ? '(Tiered)' : '(14%)'}</span>
        <span>-{formatCurrency(commission)}</span>
      </div>
      
      <div className="flex justify-between mb-2 text-gray-800">
        <span>Payment Processing Fee (1.8%)</span>
        <span>-{formatCurrency(processingFee)}</span>
      </div>
      
      <div className="border-t my-2"></div>
      
      <div className="flex justify-between mb-2 text-gray-600 text-sm">
        <span>Total Platform Fee</span>
        <span>-{formatCurrency(totalPlatformFee)}</span>
      </div>
      
      <div className="border-t my-2"></div>
      
      <div className="flex justify-between font-semibold text-gray-900">
        <span>Net Payout</span>
        <span>{formatCurrency(netPayout)}</span>
      </div>
    </div>
  );
};

export default PayoutSummary;
